<template>
  <div>
    <canvas ref="canvasRef"></canvas>
    <!-- VUE3: Inline template Will be removed at Vue 3 -->
    <noscript inline-template>
      <img class="absolute inset-0 h-auto w-full" :src="leftImage" />
    </noscript>
  </div>
</template>
<script>
import { defineComponent, ref, onMounted } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    leftImage: {
      type: String,
      required: true,
    },
    rightImage: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const canvasRef = ref(null);
    const addImageProcess = (src) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    };
    onMounted(async () => {
      try {
        const left = await addImageProcess(props.leftImage);
        const right = await addImageProcess(props.rightImage);
        const width = parseFloat(getComputedStyle(canvasRef.value, null).width.replace('px', ''));
        const height = parseFloat(getComputedStyle(canvasRef.value, null).height.replace('px', ''));
        const rect = canvasRef.value.getBoundingClientRect();
        canvasRef.value.width = width;
        canvasRef.value.height = height;
        const ctx = canvasRef.value.getContext('2d');
        let percent = 0.5;
        let touchstart = -10;
        const redraw = () => {
          const loffset = left.width * percent;
          const roffset = right.width * percent;
          const doffset = width * percent;

          ctx.clearRect(0, 0, width, height);

          if (doffset) ctx.drawImage(left, 0, 0, loffset, left.height, 0, 0, doffset, height);

          if (width - doffset) ctx.drawImage(right, roffset, 0, right.width - roffset, right.height, doffset, 0, width - doffset, height);

          ctx.beginPath();
          ctx.moveTo(doffset, 0);
          ctx.lineTo(doffset, height);
          ctx.lineWidth = 3;
          ctx.strokeStyle = '#9c9b87';
          ctx.stroke();

          ctx.beginPath();
          ctx.moveTo(doffset, height / 2 - 5);
          ctx.lineTo(doffset + 5, height / 2);
          ctx.lineTo(doffset, height / 2 + 5);
          ctx.lineTo(doffset - 5, height / 2);
          ctx.lineTo(doffset, height / 2 - 5);
          ctx.lineWidth = 5;
          ctx.strokeStyle = '#9c9b87';
          ctx.stroke();
        };

        canvasRef.value.addEventListener('click', function (e) {
          touchstart = e.touches[0].pageX;
        });

        const moveFunction = (e) => {
          const pagex = e.touches ? e.touches[0].pageX : e.pageX;

          if (Math.abs(touchstart - pagex) > 10) {
            e.preventDefault();
            e.stopPropagation();
            percent = Math.max(0, Math.min(1, (pagex - (rect.left + document.body.scrollLeft)) / width));
            requestAnimationFrame(redraw);
          }
        };

        canvasRef.value.addEventListener('touchmove', moveFunction);
        canvasRef.value.addEventListener('mousemove', moveFunction);
        canvasRef.value.addEventListener('mouseout', moveFunction);

        redraw();
      } catch (e) {}
    });
    return { canvasRef };
  },
});
</script>
<style lang="scss" scoped>
canvas {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
</style>
